import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import AuthService from './AuthService';

import { sortBy } from 'lodash'

class Clientdropdown extends Component {

    state = {
        data: [],
        selected: undefined
    }

    constructor(props) {
        super(props);

        this.getToken = this.getToken.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        if(!e) {
            this.setState({
                selected: null
            });
            this.props.onSelect(null);
            return;
        }

        const id = e.crg_energyprogramid;
        const client = this.state.data.find(x => x.crg_energyprogramid === id);
        this.setState({ selected: client.crg_energyprogramid })
        this.props.onSelect(client);
    }

    componentDidMount() {
        const bearerToken = this.getToken();

        fetch('https://simulateapiprod.azurewebsites.net/api/clients', {
        //fetch('https://astcloudrestservice.azurewebsites.net/api/clients', {
         method: 'GET',
         headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${bearerToken}`
                 },
            })
            .then(results => results.json())
            .then(data => {
        this.setState({ data: sortBy(data, ['clientName']), selected: data[0] })
        this.props.onSelect(data[0])
        })
    }

    getToken() {
        return localStorage.getItem('id_token');
    }

    render() {
        return (
            <div>
                {/* <select className="custom-select" id="clientName" value={this.state.selected} onChange={this.onChange}>
                    {this.state.data.map(item => (
                        <option key={item.crg_energyprogramid} value={item.crg_energyprogramid}>{item.clientName}</option>
                    ))
                    }
                </select> */}
                <Select
                    // className="custom-select" 
                    // id="clientName" 
                    name="client-dropdown"
                    clearable={true}
                    value={this.state.selected}
                    onChange={this.onChange}
                    options={this.state.data.map(item => {
                        item.value = item.crg_energyprogramid;
                        item.label  = item.clientName;
                        return item;
                    })}
                />
            </div>
        );
    }

}

export default Clientdropdown;



// WEBPACK FOOTER //
// ./src/components/Clientdropdown.js